import { render, staticRenderFns } from "./AssignView.vue?vue&type=template&id=c8636dcc&scoped=true"
import script from "./AssignView.vue?vue&type=script&lang=js"
export * from "./AssignView.vue?vue&type=script&lang=js"
import style0 from "../style/side-box.scss?vue&type=style&index=0&id=c8636dcc&prod&scoped=true&lang=scss&external"
import style1 from "../style/staff.scss?vue&type=style&index=1&id=c8636dcc&prod&scoped=true&lang=scss&external"
import style2 from "../style/assign-view.scss?vue&type=style&index=2&id=c8636dcc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8636dcc",
  null
  
)

export default component.exports